<template>
  <v-footer
  height="auto"
  color="primary"
  >
    <v-container
      fluid>
      <v-row
        justify=center>
        <v-col
          cols=3
          sm=3
          offset-sm=1
          md=2
          offset-md=4>
          <v-img
            :src="nucoLogo"/>
        </v-col>
        <v-col
          class="main--text white--text"
          cols=9
          sm=6>
          <h3>株式会社Nuco</h3>
          <span>東京都渋谷区東1-26-20<br>東京建物東渋谷ビル 6F</span><br>
          <span>代表：小山内美悠</span><br>
          <span>営業：平日10:00-19:00</span>
        </v-col>
      </v-row>
      <v-row
        justify=space-between>
        <v-col
          py-3
          class=white--text
          cols=auto
          >
          &copy;2019 — <strong>Prosense</strong>
        </v-col>
        <v-col
          cols=auto>
          <a href="/redirect/to-line" target="_blank">
            <v-icon
              class="sns-icon"
              dark
              large>
              fab fa-line
            </v-icon>
          </a>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import NucoLogo from '@/assets/img/nuco_logo.png'
export default {
  data () {
    return {
      nucoLogo: NucoLogo
    }
  }
}
</script>

<style scoped>
.sns-icon {
  padding: 0px 5px;
}
</style>
